// extracted by mini-css-extract-plugin
export var tag = "gene-symbol-tag-module--tag--78170";